export default {"src":"/_next/static/media/Viber.aa2a9138.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};